import { Helmet } from "react-helmet";
import WebsiteDevelopment from "../../components/solutions/website/WebsiteDevelopment";
import SolutionItemHero from "../../components/reusables/hero/SolutionItemHero";
import Authority from "../../components/reusables/Authority";
import HowWeWork from "../../components/solutions/HowWeWork";
import WebsiteFaqsBody from "../../components/faqs/WebsiteFaqsBody";
import SolutionCTA from "../../components/solutions/SolutionCTA";
import RelatedWeb from "../../components/solutions/website/RelatedWeb";

export default function Website() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/website-design-development"
        />
        <meta
          name="description"
          content="World class website design and development for companies, businesses, schools, NGOs, professionals & public figures, and e-commerce websites."
        />
        
        <meta
          property="og:description"
          content="World class website design and development for companies, businesses, schools, NGOs, professionals & public figures, and e-commerce websites."
        />
        <meta
          property="og:title"
          content="NTUNA.COM | Solutions | Website Design & Development"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM | Solutions | Website Design & Development"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Solutions | Website Design & Development"
        />
        <meta
          name="twitter:description"
          content="World class website design and development for companies, businesses, schools, NGOs, professionals & public figures, and e-commerce websites."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />
        <title>NTUNA.COM | Solutions | Website Design & Development</title>
      </Helmet>
      <SolutionItemHero
        title="Website design & development"
        subtitle="Custom high-performance and world-class websites designed to engage visitors, drive conversions and support your organization's efficiency and business's growth."
        casestudylink="/#"
        CTAtext="Get Free Quote"
        mainCTAlink="https://form.jotform.com/ntuna/get-free-quote"
      />
      <Authority />
      <WebsiteDevelopment />
      <SolutionCTA ctaTitle="Ready To Have Your Website?" />
      <WebsiteFaqsBody />
      <SolutionCTA ctaTitle="Ready To Have Your Website?" />
      <HowWeWork />
      <SolutionCTA ctaTitle="Ready To Have Your Website?" />
      <RelatedWeb />
    </>
  );
}
